import { Link } from '@reach/router'
import RichTextRenderer from 'components/UI/RichTextRenderer'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import getGatsbyImage from 'utils/getGatsbyImage'

const Wrapper = styled.div`
  background-color: #fff;
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 5;
  padding: 15px 50px;
  box-shadow: 0 -4px 3px rgba(0,0,0,0.1);
  background-position: center;
  background-size: cover;
  > .fixed-banner--content > :first-child {
    margin: 0;
    padding: 0;
    max-width: initial;
    min-height: initial;
  }

  .fixed-banner--background {
    position: absolute;
    height: 100%;
    z-index: -1;
    width: 100%;
    left: 0;
    top: 0;
    > :first-child {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
    }
  }
`

const FixedBanner = (props: Strapi.FixedBanner) => {

  const banner = useMemo(() => {
    return <Wrapper style={{ backgroundColor: props.bgColor }}>
      { props.bgImage && <div className='fixed-banner--background'><GatsbyImage image={getGatsbyImage(props.bgImage.localFile)} alt={props.bgImage.alternativeText} /></div> }
      <div className='fixed-banner--content'>
        <RichTextRenderer>
          {props.content}
        </RichTextRenderer> 
      </div>
    </Wrapper>
  }, [])

  if (props.linkTo && props.externalLink) return <a href={props.linkTo}>{banner}</a>
  if (props.linkTo && !props.externalLink) return <Link to={props.linkTo}>
    { banner }
  </Link>
  return banner
}

export default FixedBanner
